import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bc0a161"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header--center" }
const _hoisted_3 = { class: "header--left" }
const _hoisted_4 = {
  class: "back-link white",
  href: "javascript:void(0);"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_6 = {
  class: "header-bottom",
  style: {"min-height":"21px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_shared_bar = _resolveComponent("drive-shared-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header-top",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-click-back')))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.backtext')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_drive_shared_bar, {
        class: "shared-bar",
        onOnVisitChat: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('on-visit-chat')))
      })
    ])
  ]))
}